import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "../styleSheets/addTransaction.css";
import { UserContext } from "../Context/UserContext";
const AddTransaction = (props) => {
  const [users, setUsers] = useState([]);
  const { userDetails, getUserProfile } = useContext(UserContext);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const [submitLoading, setSubmitLoading] = useState(false);



  const validate = (values) => {
    const errs = {};

    if (!values.fType) errs.fType = "Category is required";

    if (!values.users || values.users.length === 0)
      errs.users = "Select at least one friend";

    if (!values.tAmount || Number(values.tAmount) <= 0)
      errs.tAmount = "Enter a valid amount";

    if (!values.paidBy) errs.paidBy = "Please select who paid";

    return errs;
  };

  const handleBlur = (e) => {
    const { name } = e.target;

    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));

    setErrors(validate(tDetails));
  };

  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  let myId = "";
  if (token) {
    const decoded = jwtDecode(token);
    myId = decoded.user.id;
  }

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/users/friends`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setUsers(data.friends))
      .catch((err) => console.error(err));
  }, []);

  const [tDetails, settDetails] = useState({
    users: [],
    tDate: "",
    tAmount: "",
    fType: "",
    tNote: "",
    tDiscount: 0,
    paidBy: "",
    tName: "",
    tStatus: "",
    tInfo: [],
    splitMode: "equal",
    splits: {},
  });

  const onChange = (e) => {
    settDetails({ ...tDetails, [e.target.name]: e.target.value });
    setErrors((prev) => ({ ...prev, users: undefined }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitLoading) return;
    const validationErrors = validate(tDetails);
    setErrors(validationErrors);
    setTouched({
      fType: true,
      users: true,
      tAmount: true,
      paidBy: true,
    });

    if (Object.keys(validationErrors).length > 0) return;

    let finalUsers = [];
    setSubmitLoading(true);
    const specialTypes = ["swiggyfood", "instamart", "creditcard"];

    if (specialTypes.includes(tDetails.fType)) {
      // remove payer
      finalUsers = tDetails.users.filter((u) => u !== tDetails.paidBy);

      // if payer is not me → include me
      if (tDetails.paidBy !== myId) {
        finalUsers.push(myId);
      }
    } else {
      // normal split
      finalUsers = [...new Set([myId, ...tDetails.users])];
    }

    let payload = {
      users: finalUsers,
      tName: tDetails.tName,
      fType: tDetails.fType,
      tNote: tDetails.tNote,
      paidBy: tDetails.paidBy,
      tAmount: tDetails.tAmount,
      splitMode: tDetails.splitMode,
    };

    payload.tDiscount = Number(tDetails.tDiscount) || 0;

    if (tDetails.tDate) {
      payload.tDate = tDetails.tDate;
    }

    if (tDetails.tStatus) {
      payload.tStatus = tDetails.tStatus;
    }
    if (tDetails.fType === "instamart") {
      payload.tName = "Groceries";
    }

    if (tDetails.cRequest) {
      payload.cRequest = tDetails.cRequest;
    }

    if (tDetails.splitMode === "manual") {
      payload.splits = finalUsers.map((uid) => ({
        user: uid,
        amount: Number(tDetails.splits[uid] || 0),
      }));
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/transaction/addTransaction`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const result = await response.json();

      if (result.success) {
        props.showAlert("Transaction Added Successfully", "success");
        await getUserProfile();
        navigate("/MoneyFlow");

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/transaction/sendTransactionEmail`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              transactionDetails: result.savedTransaction,
            }),
          },
        );
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setSubmitLoading(false);
    }
  };

  const getFinalUsers = () => {
    return [...new Set([myId, ...tDetails.users])];
  };

  useEffect(() => {
    if (tDetails.splitMode !== "manual") return;

    const users = getFinalUsers();
    const total =
      Number(tDetails.tAmount || 0) - Number(tDetails.tDiscount || 0);

    if (!users.length || !total) return;

    const perHead = total / users.length;

    const newSplits = {};
    users.forEach((u) => (newSplits[u] = perHead));

    settDetails((prev) => ({
      ...prev,
      splits: newSplits,
    }));
  }, [
    tDetails.splitMode,
    tDetails.tAmount,
    tDetails.tDiscount,
    tDetails.users,
  ]);

  const onManualSplitChange = (uid, value) => {
    const total =
      Number(tDetails.tAmount || 0) - Number(tDetails.tDiscount || 0);

    const users = getFinalUsers();

    const entered = Number(value) || 0;

    const remainingUsers = users.filter((u) => u !== uid);
    const remainingAmount = total - entered;

    const perHead =
      remainingUsers.length > 0
        ? Math.floor(remainingAmount / remainingUsers.length)
        : "";

    const newSplits = {
      [uid]: entered,
    };

    remainingUsers.forEach((u) => {
      newSplits[u] = perHead;
    });

    settDetails((prev) => ({
      ...prev,
      splits: newSplits,
    }));
  };

  const openFriendsModal = () => {
    setTouched((prev) => ({ ...prev, users: false }));
  };
  const closeFriendsModal = () => {
    setTouched((prev) => ({ ...prev, users: true }));
    setErrors(validate(tDetails));
  };

  return (
    <div className="transaction-page">
      <div className="transaction-card">
        <h2 className="transaction-title">Record a New Transaction</h2>

        {/* ================= CATEGORY + NAME ================= */}
        <div className="form-grid-2">
          <div className="form-group-modern">
            <label>Category*</label>
            <select
              className="input-modern"
              name="fType"
              value={tDetails.fType}
              onChange={onChange}
              onBlur={handleBlur}
            >
              <option value="">Select Type</option>
              <option value="restaurant">Restaurant/Cafe</option>
              {userDetails.role === "ADMIN" && (
                <option value="instamart">Instamart</option>
              )}
              {userDetails.role === "ADMIN" && (
                <option value="swiggyfood">Swiggy Food</option>
              )}
              <option value="creditcard">Card/Paid for Others</option>
              <option value="others">Miscellaneous</option>
            </select>
            {touched.fType && errors.fType && (
              <p className="error-text">{errors.fType}</p>
            )}
          </div>

          <div className="form-group-modern">
            <label>Name</label>
            <input
              type="text"
              className="input-modern"
              placeholder="Type name..."
              name="tName"
              value={tDetails.tName}
              onChange={onChange}
            />
          </div>
        </div>

        <form onSubmit={onSubmit}>
          {/* ================= FRIENDS ================= */}
          <div className="form-group-modern">
            <label>Transaction With*</label>
            <button
              type="button"
              className="input-modern friend-select-btn"
              data-bs-toggle="modal"
              data-bs-target="#friendsModal"
              onBlur={handleBlur}
            >
              {tDetails.users.length === 0
                ? "Select friends"
                : tDetails.users
                    .map((id) => users.find((u) => u._id === id)?.name)
                    .filter(Boolean)
                    .join(", ")}
            </button>
            {touched.users && errors.users && (
              <p className="error-text">{errors.users}</p>
            )}
          </div>

          {/* ================= AMOUNT + DATE ================= */}
          <div className="form-grid-2">
            <div className="form-group-modern">
              <label>Amount*</label>
              <input
                type="text"
                className="input-modern"
                placeholder="Enter amount"
                name="tAmount"
                value={tDetails.tAmount}
                onChange={onChange}
                onBlur={handleBlur}
              />
              {touched.tAmount && errors.tAmount && (
                <p className="error-text">{errors.tAmount}</p>
              )}
            </div>

            <div className="form-group-modern">
              <label>Date</label>
              <input
                type="date"
                className="input-modern"
                name="tDate"
                value={tDetails.tDate}
                onChange={onChange}
              />
            </div>
          </div>

          {/* ================= DISCOUNT ================= */}
          {(tDetails.fType === "creditcard" ||
            tDetails.fType === "restaurant" ||
            tDetails.fType === "others") && (
            <div className="form-group-modern">
              <label>Discount</label>
              <input
                type="text"
                className="input-modern"
                placeholder="Enter discount"
                name="tDiscount"
                value={tDetails.tDiscount}
                onChange={onChange}
              />
            </div>
          )}

          {/* ================= PAID BY + SPLIT ================= */}
          <div className="form-grid-2">
            <div className="form-group-modern">
              <label>Paid By*</label>
              <select
                className="input-modern"
                name="paidBy"
                value={tDetails.paidBy}
                onChange={onChange}
                onBlur={handleBlur}
              >
                <option value="">Select</option>
                <option value={myId}>You</option>
                {users
                  .filter((u) => tDetails.users.includes(u._id))
                  .map((u) => (
                    <option key={u._id} value={u._id}>
                      {u.name || u.email}
                    </option>
                  ))}
              </select>
              {touched.paidBy && errors.paidBy && (
                <p className="error-text">{errors.paidBy}</p>
              )}
            </div>

            <div className="form-group-modern">
              <label>Split Mode</label>
              <select
                className="input-modern"
                name="splitMode"
                value={tDetails.splitMode}
                onChange={onChange}
              >
                <option value="equal">Equally</option>
                <option value="manual">Manually</option>
              </select>
            </div>
          </div>

          {/* ================= MANUAL SPLIT ================= */}
          {tDetails.splitMode === "manual" && (
            <div className="manual-split-box">
              <label className="manual-title">Manual Split</label>
              {getFinalUsers().map((uid) => {
                const user =
                  uid === myId
                    ? { _id: myId, name: "You" }
                    : users.find((u) => u._id === uid);

                return (
                  <div key={uid} className="manual-row">
                    <span>{user?.name}</span>
                    <input
                      type="number"
                      className="input-modern"
                      value={tDetails.splits?.[uid] ?? ""}
                      onChange={(e) => onManualSplitChange(uid, e.target.value)}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {/* ================= NOTE ================= */}
          <div className="form-group-modern">
            <label>Note</label>
            <textarea
              className="input-modern"
              name="tNote"
              rows="3"
              value={tDetails.tNote}
              onChange={onChange}
            ></textarea>
          </div>

          {/* ================= SUBMIT ================= */}
          <div className="submit-wrapper">
            <button
              type="submit"
              className="submit-btn-modern"
              disabled={submitLoading}
            >
              {submitLoading ? (
                <span className="spinner-border spinner-border-sm"></span>
              ) : (
                "Submit Transaction"
              )}
            </button>
          </div>
        </form>
      </div>

      <div
  className="modal fade friends-modal-modern"
  id="friendsModal"
  tabIndex="-1"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered friends-modal-dialog-modern">
    <div className="modal-content friends-modal-content-modern">

      {/* Drag Handle (Mobile Only) */}
      <div className="bottom-sheet-handle"></div>

      {/* Header */}
      <div className="friends-modal-header-modern">
        <h5 className="friends-modal-title-modern">
          Select Friends
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>

      {/* Body */}
      <div className="friends-modal-body-modern">

        {users.length === 0 ? (
          <div className="friends-empty-modern">
            No friends available
          </div>
        ) : (
          users.map((user) => {
            const isSelected = tDetails.users.includes(user._id);

            return (
              <div
                key={user._id}
                className={`friends-row-modern ${
                  isSelected ? "friends-selected-modern" : ""
                }`}
                onClick={() => {
                  const id = user._id;

                  if (isSelected) {
                    settDetails({
                      ...tDetails,
                      users: tDetails.users.filter((u) => u !== id),
                    });
                  } else {
                    settDetails({
                      ...tDetails,
                      users: [...tDetails.users, id],
                    });
                  }
                }}
              >
                <img
                  className="friends-avatar-modern"
                  src={
                    user.profilePicture?.url ||
                    "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg"
                  }
                  alt="profile"
                />

                <div className="friends-info-modern">
                  <span className="friends-name-modern">
                    {user.name || user.email}
                  </span>
                </div>

                {isSelected && (
                  <div className="friends-tick-modern">
                    ✓
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* Footer */}
      <div className="friends-modal-footer-modern">
        <button
          type="button"
          className="friends-done-btn-modern"
          data-bs-dismiss="modal"
          onClick={closeFriendsModal}
        >
          Done
        </button>
      </div>

    </div>
  </div>
</div>
    </div>
  );
};

export default AddTransaction;
